package shared.content

import shared.models.FooterNavLink
import shared.models.NavLink

object NavigationDefaults {

    val headerLinks = emptyList<NavLink>()

    val footerLinks = listOf(
        FooterNavLink("/privacy-policy", "Privacy policy", true),
        FooterNavLink("/terms", "Terms", true)
    )
}
